module.exports = __webpack_public_path__ + "fonts/inter-v20-latin-500.51205681.woff2";